import { render, staticRenderFns } from "./SubFieldType.vue?vue&type=template&id=9713e4e0&"
import script from "./SubFieldType.vue?vue&type=script&lang=js&"
export * from "./SubFieldType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports